import React from 'react';  // import the React library
import {Helmet} from "react-helmet";
 
function MetaTags(props) {
    return (
        <>
          <Helmet>
<meta charset="utf-8" />
<meta name="google-site-verification" content="9M5Q-_AQk19k6xQyIohsE70q2rkezqtsaELmvh9OfMs" />
<link rel="icon" type="image/ico" href="%PUBLIC_URL%/highway.ico" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<meta name="theme-color" content="#000000" />
<script src="https://use.fontawesome.com/ae82b2007b.js"></script>
<link rel="apple-touch-icon" href="%PUBLIC_URL%/logo192.png" />
<link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
<link rel="preconnect" href="https://fonts.gstatic.com" />
<link href="https://fonts.googleapis.com/css2?family=Gentium+Book+Basic&family=Yesteryear&display=swap" rel="stylesheet" />

<title>{props.title}</title>
<meta name="description" content={props.desc}/>
<meta name="author" content={props.author} />

<meta name="og:site_name" content="Highway 60" />
<meta name="og:type" content="Application" />
<meta name="og:title" content={props.title} />
<meta name="og:description" content={props.desc} />
<meta name="og:url" content={props.URL} />
<meta property="og:image" content={props.imageURL}/> 

<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:creator" content="@TheHighway60" />
<meta name="twitter:title" content={props.title} />
<meta name="twitter: description" content={props.desc} />
<meta name="twitter: url" content={props.URL} />
<meta property="twitter:image" content={props.imageURL} />
  </Helmet>
        </>
        );
    }
  
  export default MetaTags;